
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class EmployeeMasterGrid extends Serenity.EntityGrid<EmployeeMasterRow, any> {
        protected getColumnsKey() { return 'Master.EmployeeMaster'; }
        protected getDialogType() { return EmployeeMasterDialog; }
        protected getIdProperty() { return EmployeeMasterRow.idProperty; }
        protected getInsertPermission() { return EmployeeMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return EmployeeMasterRow.localTextPrefix; }
        protected getService() { return EmployeeMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}